import { render, staticRenderFns } from "./TagReport.vue?vue&type=template&id=e2766e36&"
import script from "./TagReport.vue?vue&type=script&lang=ts&"
export * from "./TagReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports